import React from 'react';
import { markVersionAsSeen } from '../../hooks/versionService';
import { Button, Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'fixed',
    bottom: 12,
    left: 12,
    right: 12,
    backgroundColor: '#1f2937',
    color: 'white',
    padding: theme.spacing(1.5),
    borderRadius: theme.shape.borderRadius,
    zIndex: 9999,
    display: 'flex',
    gap: theme.spacing(1.5),
    alignItems: 'center',
    justifyContent: 'space-between',
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
  },
  buttonGroup: {
    display: 'flex',
    gap: theme.spacing(1)
  },
  button: {
    color: 'white'
  },
  refreshNow: {
    backgroundColor: '#10b981',
    color: 'white',
    '&:hover': {
      backgroundColor: '#059669'
    }
  }
}));

type Props = {
  onRefreshNow: () => void;
};

export function UpdateBanner({ onRefreshNow }: Props) {
  const classes = useStyles();
  const [updating, setUpdating] = React.useState(false);

  const handleRefreshNow = () => {
    setUpdating(true);
    markVersionAsSeen();
    onRefreshNow();
  };

  return (
    <div className={classes.root}>
      <Typography variant="body2">New version available. Refresh to get the latest updates.</Typography>
      <div className={classes.buttonGroup}>
        <Button
          size="small"
          variant="contained"
          onClick={handleRefreshNow}
          disabled={updating}
          className={classes.refreshNow}
        >
          {updating ? 'Refreshing…' : 'Refresh Now'}
        </Button>
      </div>
    </div>
  );
}
